import $ from "jquery";

const init = () => {
  postShareBtn();
};

const el = {
  main: ".mi-post-share",
};

const postShareBtn = () => {
  if ($(el.main).length < 0) return;

  $(el.main).on("click", "[data-type]", function (e) {
    e.preventDefault();

    var type = $(this).data("type");
    var postUrl = encodeURIComponent(window.location.href);
    var postTitle = encodeURIComponent(document.title); // optional text

    switch (type) {
      case "copy":
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(window.location.href)
            .then(() => alert("Link copied to clipboard!"))
            .catch(() => alert("Failed to copy link."));
        } else {
          // Fallback for older browsers
          var tempInput = $("<input>");
          $("body").append(tempInput);
          tempInput.val(window.location.href).select();
          document.execCommand("copy");
          tempInput.remove();
          alert("Link copied to clipboard!");
        }
        break;

      case "social-x":
        window.open(
          "https://twitter.com/intent/tweet?url=" +
            postUrl +
            "&text=" +
            postTitle,
          "_blank"
        );
        break;

      case "social-fb":
        window.open(
          "https://www.facebook.com/sharer/sharer.php?u=" + postUrl,
          "_blank"
        );
        break;
    }
  });
};

try {
  init();
} catch (error) {
  console.log(`Error Tesimonial Slider: `, error);
}
